module.exports = __webpack_public_path__ + "img/jtb-avatar-7557.e68eb540.jpg";